import { Component } from 'react'
import type { ReactNode } from 'react'

interface RoundErrorBoundaryProps {
  readonly fallback: ReactNode
  readonly children: ReactNode
}

interface RoundErrorBoundaryState {
  hasError: boolean
}

/**
 * Limite d'erreur autour du `Round` paresseux d'une mécanique.
 *
 * Nécessaire uniquement pour intercepter l'échec de chargement d'un chunk
 * (mécanique jamais déposée, ou coupure réseau pendant le téléchargement) :
 * React n'offre pas d'équivalent en composant fonctionnel, une limite
 * d'erreur doit rester une classe.
 */
export class RoundErrorBoundary extends Component<RoundErrorBoundaryProps, RoundErrorBoundaryState> {
  state: RoundErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(): RoundErrorBoundaryState {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) return this.props.fallback
    return this.props.children
  }
}
